import React, { useEffect } from 'react';
import { initPixel, trackPageView, trackAddToCart } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainGrid } from './components/PainGrid';
import { MethodSection } from './components/MethodSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferCard } from './components/OfferCard';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FooterSection } from './components/FooterSection';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  const handleCtaClick = () => {
    trackAddToCart();
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-pure-white font-sans selection:bg-pistachio selection:text-slate-dark" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main className="overflow-hidden" data-id="element-2">
        <HeroSection onCtaClick={handleCtaClick} data-id="element-3" />
        <PainGrid data-id="element-4" />
        <MethodSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />

        <div id="offer-section" data-id="element-7">
          <OfferCard onCtaClick={handleCtaClick} data-id="element-8" />
        </div>

        <GuaranteeSection data-id="element-9" />
        <FaqSection data-id="element-10" />
      </main>

      <FooterSection data-id="element-11" />
      <StickyMobileCTA onCtaClick={handleCtaClick} data-id="element-12" />
    </div>;
}